import { render, staticRenderFns } from "./promoterInfo.vue?vue&type=template&id=fd36f31c&scoped=true"
import script from "./promoterInfo.vue?vue&type=script&lang=js"
export * from "./promoterInfo.vue?vue&type=script&lang=js"
import style0 from "./promoterInfo.vue?vue&type=style&index=0&id=fd36f31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd36f31c",
  null
  
)

export default component.exports